import { create } from "zustand";

const initialState = {
  productSearch: "",
  selectedProducts: [],
  importFile: null,
  isProductSearchOpen: false,
};

const useCampaignStore = create((set) => ({
  ...initialState,

  setProductSearch: (productSearch) => {
    set({
      productSearch,
      isProductSearchOpen: productSearch.trim().length >= 2,
    });
  },

  setIsProductSearchOpen: (isProductSearchOpen) =>
    set({ isProductSearchOpen }),

  openProductSearch: () => {
    set({
      isProductSearchOpen: true,
    });
  },

  closeProductSearch: () => {
    set({
      isProductSearchOpen: false,
    });
  },

  addSelectedProduct: (product) => {
    set((state) => {
      const exists = state.selectedProducts.some(
        (item) => item.id === product.id
      );

      if (exists) {
        return state;
      }

      return {
        selectedProducts: [
          ...state.selectedProducts,
          product,
        ],
      };
    });
  },

  removeSelectedProduct: (productId) => {
    set((state) => ({
      selectedProducts: state.selectedProducts.filter(
        (product) => product.id !== productId
      ),
    }));
  },

  setSelectedProducts: (selectedProducts) => {
    set({
      selectedProducts,
    });
  },

  setImportFile: (importFile) => {
    set({
      importFile,
    });
  },

  resetCampaignDraft: () => {
    set(initialState);
  },
}));

export default useCampaignStore;
